/**
 * Checkout shipping country list (ISO 3166-1 alpha-2).
 * Used for the country select and to normalize Google Places / saved addresses.
 */

const REST = [
  { code: 'NZ', label: 'New Zealand' },
  { code: 'US', label: 'United States' },
  { code: 'GB', label: 'United Kingdom' },
  { code: 'CA', label: 'Canada' },
  { code: 'DE', label: 'Germany' },
  { code: 'FR', label: 'France' },
  { code: 'IT', label: 'Italy' },
  { code: 'ES', label: 'Spain' },
  { code: 'NL', label: 'Netherlands' },
  { code: 'BE', label: 'Belgium' },
  { code: 'CH', label: 'Switzerland' },
  { code: 'AT', label: 'Austria' },
  { code: 'IE', label: 'Ireland' },
  { code: 'SE', label: 'Sweden' },
  { code: 'NO', label: 'Norway' },
  { code: 'DK', label: 'Denmark' },
  { code: 'FI', label: 'Finland' },
  { code: 'PL', label: 'Poland' },
  { code: 'PT', label: 'Portugal' },
  { code: 'GR', label: 'Greece' },
  { code: 'CZ', label: 'Czech Republic' },
  { code: 'HU', label: 'Hungary' },
  { code: 'RO', label: 'Romania' },
  { code: 'JP', label: 'Japan' },
  { code: 'KR', label: 'South Korea' },
  { code: 'CN', label: 'China' },
  { code: 'HK', label: 'Hong Kong' },
  { code: 'SG', label: 'Singapore' },
  { code: 'MY', label: 'Malaysia' },
  { code: 'TH', label: 'Thailand' },
  { code: 'VN', label: 'Vietnam' },
  { code: 'PH', label: 'Philippines' },
  { code: 'ID', label: 'Indonesia' },
  { code: 'IN', label: 'India' },
  { code: 'PK', label: 'Pakistan' },
  { code: 'BD', label: 'Bangladesh' },
  { code: 'AE', label: 'United Arab Emirates' },
  { code: 'SA', label: 'Saudi Arabia' },
  { code: 'IL', label: 'Israel' },
  { code: 'ZA', label: 'South Africa' },
  { code: 'EG', label: 'Egypt' },
  { code: 'NG', label: 'Nigeria' },
  { code: 'KE', label: 'Kenya' },
  { code: 'BR', label: 'Brazil' },
  { code: 'MX', label: 'Mexico' },
  { code: 'AR', label: 'Argentina' },
  { code: 'CL', label: 'Chile' },
  { code: 'CO', label: 'Colombia' },
  { code: 'PE', label: 'Peru' },
  { code: 'RU', label: 'Russia' },
  { code: 'TR', label: 'Turkey' },
  { code: 'UA', label: 'Ukraine' },
  { code: 'FJ', label: 'Fiji' },
  { code: 'PG', label: 'Papua New Guinea' },
  { code: 'MC', label: 'Monaco' },
  { code: 'LU', label: 'Luxembourg' },
  { code: 'IS', label: 'Iceland' },
  { code: 'MT', label: 'Malta' },
  { code: 'CY', label: 'Cyprus' },
  { code: 'EE', label: 'Estonia' },
  { code: 'LV', label: 'Latvia' },
  { code: 'LT', label: 'Lithuania' },
  { code: 'SK', label: 'Slovakia' },
  { code: 'SI', label: 'Slovenia' },
  { code: 'HR', label: 'Croatia' },
  { code: 'BG', label: 'Bulgaria' },
  { code: 'TW', label: 'Taiwan' },
  { code: 'MO', label: 'Macau' },
  { code: 'QA', label: 'Qatar' },
  { code: 'KW', label: 'Kuwait' },
];

REST.sort((a, b) => a.label.localeCompare(b.label));

/** Australia first, then alphabetical. */
export const CHECKOUT_COUNTRIES = [{ code: 'AU', label: 'Australia' }, ...REST];

const LABEL_LOWER_TO_CODE = new Map(CHECKOUT_COUNTRIES.map((c) => [c.label.toLowerCase(), c.code]));

/** Google Places and common aliases → ISO code */
const ALIAS_TO_CODE = {
  usa: 'US',
  'u.s.': 'US',
  'u.s.a.': 'US',
  uk: 'GB',
  britain: 'GB',
  'great britain': 'GB',
  england: 'GB',
  scotland: 'GB',
  wales: 'GB',
  'northern ireland': 'GB',
  holland: 'NL',
  korea: 'KR',
  'south korea': 'KR',
  'czechia': 'CZ',
  turkiye: 'TR',
  türkiye: 'TR',
};

/**
 * @param {string | null | undefined} input — Google `long_name`, ISO2, or legacy full name
 * @returns {string} ISO 3166-1 alpha-2
 */
export function countryToCodeFromGoogleOrLabel(input) {
  if (input == null || !String(input).trim()) return 'AU';
  const s = String(input).trim();
  if (s.length === 2) return s.toUpperCase();
  const lower = s.toLowerCase();
  if (ALIAS_TO_CODE[lower]) return ALIAS_TO_CODE[lower];
  const fromLabel = LABEL_LOWER_TO_CODE.get(lower);
  if (fromLabel) return fromLabel;
  return 'AU';
}

/** @param {string | null | undefined} code — ISO2 or legacy full name */
export function isAustraliaCountryCode(code) {
  const c = String(code || '').trim().toUpperCase();
  if (!c) return true;
  return c === 'AU' || c === 'AUSTRALIA' || c === 'AUS';
}
